import { useState } from "react";
import { faqs } from "../../../mocks/starTracker";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
      <div className="mx-auto max-w-[1000px] px-4 md:px-6 lg:px-10">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
            <i className="ri-questionnaire-line text-base"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于追踪与事件，你想问的都在这
          </h2>
        </div>

        <div className="mt-9 space-y-3">
          {faqs.map((f, i) => (
            <div
              key={f.q}
              className={`overflow-hidden rounded-lg ring-1 transition-colors ${
                open === i ? "bg-background-100 ring-background-300" : "bg-background-100 ring-background-200"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
                className="flex w-full items-center gap-4 px-5 py-4 text-left"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-600 font-label text-sm font-bold text-background-50">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1 font-heading text-base font-bold text-foreground-950">{f.q}</span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50 text-primary-700 ring-1 ring-background-200 transition-transform ${
                    open === i ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line"></i>
                </span>
              </button>
              {open === i && (
                <p className="border-t border-background-200 px-5 py-4 pl-[4.5rem] text-sm leading-relaxed text-foreground-600">
                  {f.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}